let hideBtnstatus = function() {
	this.statusdropd = false;
};
export default hideBtnstatus;
